//
//

import i18n from "@/i18n/index";
import { date } from "quasar";
import { APP_DATE_DOT_FORMAT } from "@/assets/js/appConfig";
import shortId from "short-uuid";
import { mapGetters, mapMutations, mapActions } from "vuex";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import DiagramWrapper from "@/components/Diagram/DiagramWrapper/DiagramWrapper.vue";
import { publishAppPermissions, infoToastPublish } from "@/assets/js/appFunc";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQDefaultState from "@/components/Generics/AQDefaultState/AQDefaultState.vue";
import AQEmptyState from "@/components/Generics/AQEmptyState/AQEmptyState.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQSkeleton from "@/components/Generics/AQSkeleton/AQSkeleton.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQList from "@/components/Generics/AQList/AQList.vue";
import AQSearch from "@/components/Generics/AQSearch/AQSearch.vue";
import AQEmptySearch from "@/components/Generics/AQEmptySearch/AQEmptySearch.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQHistory from "@/components/Generics/AQHistory/AQHistory.vue";
import addAttributeModal from "./addFieldsModal/addAttributeModal.vue";
import addNewClassModal from "./addNewClassModal/addNewClassModal.vue";
import { getDataModel, saveGenericModelDefinition, saveDataModelClass } from "./DataModelHelpers";

export default {
    name: "DataModel",
    components: {
        DiagramWrapper,
        AQInput,
        addAttributeModal,
        addNewClassModal,
        AQDialog,
        AQDefaultState,
        AQEmptyState,
        AQButton,
        AQSkeleton,
        AQCard,
        AQList,
        AQSearch,
        AQEmptySearch,
        AQModal,
        AQHistory
    },
    beforeRouteLeave(to, from, next) {
        if (from.name !== to.name && this.unsavedChanges) {
            this.$store.commit("main/setInterfaceDirty", true);
        }
        next();
    },
    props: {
        permissionCode: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            showDlg: false,
            showDlgDataModal: false,
            readonly: false,
            sendBlockChainToggle: false,
            diagramAttrToDelete: [],
            /// ////// from STORE /////////////
            classToAdd: null,
            classUuid: null,
            propertyUuid: null,
            temporaryClassInfo: {},
            parentClassArray: [],
            isInEdit: false,
            initialClassName: null,
            propertyNameFromEdit: null,
            propertyTypeFromEdit: null,
            blockLabelFromEdit: null,
            isEmbeddedFromEdit: null,
            isCat: null,
            isIndexableFromEdit: null,
            isListFromEdit: null,
            isPersonalInformationFromEdit: false,
            classNameFromEdit: null,
            isBCReadyFromEdit: false,
            diagramVersion: null,
            dataFromGetResponse: null,
            noAddingYet: false,
            parentClassData: null,
            classNameFromStore: "",
            oneAtATimeActive: false,
            editAtr: false,
            attributes: null,
            indexAttr: null,
            disabledSavebtn: true,
            fromBus: false,
            toastExist: false,
            dataUpdateNotify: null,
            initialDigram: null,
            emptyState: false,
            skeletonState: true,
            checkObjAttr: null,
            counter: 0,
            initialDataModel: null,
            search: "",
            id: "",
            commitId: "",
            saveHistoryDMModal: false,
            keyUpdateDM: 0,
            saveHistoryData: [],
            saveHistoryCurrentPage: 0,
            saveHistoryDMHasMoreItems: true,
            saveHistoryActiveCommitId: null,
            timeStampPreview: null,
            restoreConfirmationDialog: false,
            restoreDialogMessage: null,
            standaloneTypes: new Set(["publish", "delete"]),
            dialogAction: "",
            previewDone: false,
            dirtyFromRestore: false,
            restoredDMData: null,
            currentPreviewData: null,
            noteDialog: false,
            noteDialogTitle: null,
            confirmLabel: null,
            note: null,
            createNote: false,
            savePreviewToast: null,
            openDialogDraftPreview: false,
            actionMade: false,
            searchTrigger: false,
            isActive: true,
            unsavedChanges: false
        };
    },
    computed: {
        ...mapGetters("version", ["latestVersionId"]),
        ...mapGetters("main", ["getCurrentApplicationId", "interfaceDirty"]),
        ...mapGetters("catalogs", ["getMasterId"]),
        ...mapGetters("apps", ["currentApp", "processList", "getCurrentAppUserPermissions"]),
        config() {
            return { readonly: this.readonly };
        },
        classesListForModal() {
            return this.parentClassArray.map(element => element.name);
        },
        createNoteDisabled() {
            return !this.note && this.createNote;
        },
        filteredClasses() {
            let classesList = [];
            if (this.search) {
                const searchClassLowerCase = this.search.toLowerCase();
                classesList = this.parentClassArray.reduce((acc, currentClass) => {
                    const filteredClass = JSON.parse(JSON.stringify(currentClass));
                    filteredClass.fields = currentClass.fields.filter(field => field.name.toLowerCase().includes(searchClassLowerCase));
                    if (filteredClass.fields.length > 0 || currentClass.name.toLowerCase().includes(searchClassLowerCase)) {
                        acc.push(filteredClass);
                    }
                    return acc;
                }, []);
            } else {
                classesList = this.parentClassArray;
            }
            return classesList;
        },
        searchResults() {
            let countClasses = 0;
            let countAttributes = 0;
            const searchClassLowerCase = this.search.toLowerCase();
            for (let i = 0; i < this.parentClassArray.length; i++) {
                if (this.parentClassArray[i].name.toLowerCase().includes(searchClassLowerCase)) {
                    countClasses++;
                }
                for (let j = 0; j < this.parentClassArray[i].fields.length; j++) {
                    if (this.parentClassArray[i].fields[j].name.toLowerCase().includes(searchClassLowerCase)) {
                        countAttributes++;
                    }
                }
            }
            return { cls: countClasses, atr: countAttributes };
        }
    },
    watch: {
        dataFromGetResponse(v) {
            this.setParentClassArray(v.modelClasses);
            this.checkPermissions(this.oneAtATimeActive);
        },
        getCurrentApplicationId() {
            this.parentClassArray = [];
        },
        showSearch: {
            handler(newVal) {
                this.searchTrigger = newVal;
                setTimeout(() => {
                    this.searchTrigger = false;
                }, 0);
            },
            immediate: true
        }
    },
    created() {
        this.$store.dispatch("diagrams/getDiagramPlugins");
        if (!this.processList.length) {
            this.getAppProcesses({ applicationId: this.currentApp.id, searchTerm: "" }).then(rsp => {
                if (rsp.data) {
                    this.$store.commit("apps/setProcessList", rsp.data);
                    this.$root.$emit("showPublish", { noProcesses: !this.processList.length,
                        showPublish: this.publishAppPermissions(this.currentApp, this.getCurrentAppUserPermissions) });
                }
            });
        }
        this.getLatestVersionId().then(() => {
            this.diagramVersion = this.latestVersionId;
        });

        this.$root.$on("dataModelSave", () => {
            const objectToSend = {
                diagram: "",
                diagramId: this.diagramId,
                masterId: this.getMasterId,
                versionId: this.diagramVersion,
                applicationId: this.getCurrentApplicationId,
                commitId: this.attributes ? null : this.commitId,
                id: this.id || shortId.uuid(),
                modelClasses: this.parentClassArray
            };
            if (!this.id) {
                this.id = objectToSend.id;
            }
            saveDataModelClass(objectToSend).then(data => {
                if (data.data) {
                    this.emptyState = !this.parentClassArray.length;
                    this.initialDataModel = [...this.parentClassArray];
                    const { commitId, diagramId, masterId, status } = data.data;
                    this.currentApp.publishStatus = status ? "UNPUBLISHED_CHANGES" : "PUBLISHED";
                    this.$store.commit("apps/setCurrentApp", this.currentApp);
                    this.diagramId = diagramId;
                    if (status) {
                        this.commitId = commitId;
                        this.$store.commit("catalogs/setMasterId", masterId);
                    }
                    this.disabledSavebtn = true;
                }
                this.disabledSavebtn = true;
                this.unsavedChanges = false;
                this.$toast.showNotify({
                    type: "success",
                    message: this.$t("generic.savedSuccessfully"),
                    timeout: 500
                });
                this.$root.$emit("hideSaveBtn", false);
                this.$root.$emit("showCheckedSaveBtn", true);
                this.$store.commit("main/setInterfaceDirty", false);
            },
            () => {
                this.$root.$emit("showCheckedSaveBtn", false);
                this.$store.commit("main/setInterfaceDirty", true);
                this.$toast.showNotify({
                    type: "error",
                    message: this.$t("generic.saveUnsuccessful"),
                    timeout: 1000
                });
            });
            if (this.attributes) {
                this.attributes = null;
            }
        });

        // OneAtATime logic
        this.$root.$on("oneAtATime-dataModel", () => {
            const data = { readonly: !this.$oneAtATime.state.$currentRoomEmpty };
            if ((this.readonly && this.$oneAtATime.state.$currentRoomEmpty) || !this.$oneAtATime.state.$currentRoomEmpty) {
                this.refreshData(data);
            } else {
                this.checkPermissions(data);
            }
        });
        this.$root.$on("showMoreSaveHistory", () => {
            this.saveHistoryCurrentPage += 1;
            this.getSaveHistoryDM();
        });
        this.$root.$on("restore", () => {
            this.infoRestoreDialog();
            this.restoreConfirmationDialog = true;
        });
        this.$root.$on("previewSaveHistoryClose", routeName => {
            if (routeName === this.$route.name) {
                if (this.savePreviewToast) {
                    this.savePreviewToast();
                }
                this.saveHistoryActiveCommitId = null;
                this.dirtyFromRestore = false;
                this.$store.commit("main/setInterfaceDirty", false);
                this.$root.$emit("hideSaveBtn", false);
                this.parentClassArray = JSON.parse(JSON.stringify(this.initialDataModel)) || [];
                this.emptyState = !this.parentClassArray.length;
                this.readonly = false;
                this.timeStampPreview = null;
                this.$root.$emit("showCheckedSaveBtn", true);
                this.$root.$emit("showPublish", { noProcesses: !this.processList.length,
                    showPublish: this.publishAppPermissions(this.currentApp, this.getCurrentAppUserPermissions) });
            }
        });
        this.$root.$on("openNoteDialog", routeName => {
            if (routeName === this.$route.name) {
                this.getNoteData();
            }
        });
    },
    destroyed() {
        this.$root.$off("dataModelSave");
        this.$root.$off("openNoteDialog", this.$route.name);
        this.$root.$off("previewSaveHistoryClose", this.$route.name);
        this.$root.$off("oneAtATime-dataModel");
        this.$root.$off("showMoreSaveHistory", this.$route.name);
        this.$root.$off("restore");
        this.$root.$emit("previewSaveHistoryHeaderClose", this.$route.name);
    },
    activated() {
        this.$store.commit("main/setSaveBtnVisible", false);
        this.saveHistoryActiveCommitId = null;
        this.previewDone = false;
        this.$root.$emit("previewSaveHistoryHeaderClose", this.$route.name);
        this.$root.$emit("showCheckedSaveBtn", { showSaveBtn: true, persistSaveBtnState: true });
        this.$store.commit("rules/setShowRuleTesting", false);
        if (this.processList.length) {
            this.$root.$emit("showPublish", { noProcesses: !this.processList.length,
                showPublish: this.publishAppPermissions(this.currentApp, this.getCurrentAppUserPermissions) });
        }
        this.$root.$on("backendWebsocketEvents-refreshClassData", data => {
            if (data.id) {
                this.refreshDataWebsocket();
            }
        });
        this.$root.$on("backendWebsocketEvents-publishedApp", data => {
            infoToastPublish(data);
            this.$root.$emit("changePublishError");
        });
        this.$root.$on("openSaveHistory", () => {
            if (this.saveHistoryActiveCommitId) {
                if (this.savePreviewToast) {
                    this.savePreviewToast();
                }
                this.actionMade = false;
                this.saveHistoryDMModal = true;
                this.$nextTick(() => {
                    const activePreviewListItem = document.querySelectorAll(".timeline_list_item.active.edit");
                    if (activePreviewListItem.length) {
                        activePreviewListItem[0].scrollIntoView();
                    }
                });
            } else {
                this.resetSaveHistory();
                this.getSaveHistoryDM();
            }
        });
        getDataModel().then(data => {
            if (data && data.data) {
                this.diagramId = data.data.diagramId;
                this.commitId = data.data.commitId;
                this.id = data.data.id;
                if (data.data.modelClasses && data.data.modelClasses.length > 0) {
                    this.skeletonState = false;
                    this.setGeneralModelDef(data);
                    this.initialDataModel = [...data.data.modelClasses];
                    this.$store.commit("catalogs/setDataModelList", data.data.modelClasses);
                } else {
                    this.emptyState = true;
                    this.skeletonState = false;
                }
            } else {
                this.emptyState = true;
                this.skeletonState = false;
            }
        });
        const { query } = this.$route;
        if (query && Object.keys(query).length && query.search) {
            this.searchTrigger = true;
            this.search = query.search;
        }
        this.isActive = true;
    },
    mounted() {
        this.checkPermissions();
    },
    deactivated() {
        this.counter++;
        this.$root.$off("backendWebsocketEvents-publishedApp");
        this.emptyState = false;
        this.skeletonState = true;
        if (this.savePreviewToast) {
            this.savePreviewToast();
        }
        this.refreshNotify();
        this.$root.$off("openSaveHistory");
        this.isActive = false;
    },
    methods: {
        ...mapActions("version", ["getLatestVersionId"]),
        ...mapMutations("main", ["setInterfaceDirty"]),
        ...mapMutations("catalogs", ["setMasterId"]),
        ...mapActions("apps", ["getAppProcesses", "getAppSettingsInfo", "updateProcessInstance"]),
        ...mapActions("components", ["getHistoryData", "getHistoryDMPreviewData", "setReadonly", "saveDeleteNote", "getNote"]),
        publishAppPermissions,
        addClassModel() {
            this.$nextTick(() => {
                this.isInEdit = false;
                this.editAtr = false;
                this.showDlgDataModal = true;
                this.initialClassName = null;
            });
        },
        editClassModal(item) {
            this.classUuid = item.id;
            this.isInEdit = true;
            this.initialClassName = item.name;
            this.classNameFromEdit = item.name;
            this.showDlgDataModal = true;
        },
        sortParentArray() {
            this.parentClassArray.sort((a, b) => {
                const classNameA = a.name.toLowerCase();
                const classNameB = b.name.toLowerCase();
                if (classNameA < classNameB) return -1;
                if (classNameA > classNameB) return 1;
                return 0;
            });
        },
        infoRestoreDialog(timelineItem) {
            this.restoredDMData = timelineItem || this.currentPreviewData;
            const restoreElementData = timelineItem && timelineItem.timestamp ? `${this.dateFormatter(timelineItem.timestamp)}`
                : `${this.dateFormatter(this.currentPreviewData.timestamp)}`;
            this.restoreDialogMessage = this.$t("versioning.restoreDialogInfoDM", { date: restoreElementData });
        },
        confirmRestore() {
            this.actionMade = true;
            if ((this.previewDone && this.restoredDMData && this.restoredDMData !== this.currentPreviewData) || !this.previewDone) {
                const payload = {
                    module: "DataModel",
                    applicationId: this.currentApp.id,
                    elementId: this.id,
                    commitId: this.restoredDMData.commitId
                };
                this.getHistoryDMPreviewData(payload).then(data => {
                    if (data && data.data) {
                        this.$root.$emit("hideSaveBtn", false);
                        this.$root.$emit("showCheckedSaveBtn", false);
                        this.$root.$emit("confirmRestore", this.$route.name);
                        this.parentClassArray = data.data.modelClasses;
                        this.emptyState = !data.data.modelClasses;
                        this.timeStampPreview = data.data.timestamp;
                        this.previewDone = false;
                    }
                });
            }
            this.$root.$emit("showPublish", { noProcesses: this.currentApp.hasOwnProperty("nrOfProcesses")
                ? !this.currentApp.nrOfProcesses : !this.processList.length,
            showPublish: publishAppPermissions(this.currentApp, this.getCurrentAppUserPermissions) });
            this.saveHistoryActiveCommitId = null;
            this.readonly = false;
            this.resetSaveHistory();
            this.dirtyFromRestore = true;
            this.$store.commit("main/setInterfaceDirty", true);
            this.saveHistoryDMModal = false;
            this.actionMade = false;
            this.previewDone = false;
            this.setReadonly(false);
            this.$root.$emit("hideSaveBtn", false);
            this.$root.$emit("showCheckedSaveBtn", false);
            this.$root.$emit("confirmRestore", this.$route.name);
            this.$toast.showNotify({
                type: "success",
                message: this.$t("versioning.confirmRestoreNotify"),
                timeout: 2000
            });
        },
        resetSaveHistory() {
            this.saveHistoryData = [];
            this.saveHistoryCurrentPage = 0;
            this.saveHistoryDMHasMoreItems = true;
            this.saveHistoryActiveCommitId = null;
            if (this.savePreviewToast) {
                this.savePreviewToast();
            }
        },
        historyMenuClick(evt) {
            this.dialogAction = evt.actionName;
            if (this.dialogAction === "restore") {
                this.infoRestoreDialog(evt.timelineItem);
                this.restoreConfirmationDialog = true;
            }
        },
        getFilteredAttributes(classFilter) {
            let messageToShow = "";
            let classFiltered = [];
            if (this.search) {
                classFiltered = this.parentClassArray.filter(el => el.id === classFilter.id);
                messageToShow = `${classFiltered[0].fields.length}
                ${this.$tc("dataModel.attributesCounter", classFiltered[0].fields.length)}`;
            } else {
                messageToShow = `${classFilter.fields.length}
                ${this.$tc("dataModel.attributesCounter", classFilter.fields.length)}`;
            }
            return messageToShow;
        },
        getDisableState(elem) {
            return this.search.length && !elem.fields.length;
        },
        getCardOpen(elem) {
            return this.search.length > 0 && elem.fields.length > 0;
        },
        saveClass() {
            if (this.parentClassArray.length && this.emptyState) {
                this.emptyState = false;
            }
            this.sortParentArray();
            this.unsavedChanges = true;
            this.$root.$emit("showCheckedSaveBtn", false);
        },
        saveDiagramCanvas() {
            const objectToSend = {
                diagram: "",
                diagramId: this.diagramId,
                modelClasses: null,
                masterId: this.getMasterId,
                versionId: this.diagramVersion
            };

            saveGenericModelDefinition(objectToSend).then(
                () => {
                    this.$root.$emit("showCheckedSaveBtn", { showSaveBtn: true, persistSaveBtnState: false });
                    this.$toast.showNotify({
                        type: "success",
                        message: this.$t("generic.savedSuccessfully"),
                        timeout: 500
                    });
                },
                error => {
                    if (error.response.status !== 406) {
                        this.$root.$emit("showCheckedSaveBtn", { showSaveBtn: false, persistSaveBtnState: false });
                        this.$toast.showNotify({
                            type: "error",
                            message: this.$t("generic.saveUnsuccessful"),
                            timeout: 1000
                        });
                    }
                }
            );
        },
        deleteClass(id) {
            for (let i = 0; i < this.parentClassArray.length; i++) {
                if (this.parentClassArray[i].id === id) {
                    this.parentClassArray.splice(i, 1);
                    break;
                }
            }
            this.emptyState = !this.parentClassArray.length;
            this.isInEdit = false;
            this.showDlgDataModal = false;
            this.$store.commit("main/setInterfaceDirty", true);
            this.$root.$emit("showCheckedSaveBtn", false);
        },
        diagramEvent(data) {
            const vm = this;
            if (data.type === "PLUGIN_SELECTED") { // selectare clasa
                vm.$store.commit("diagrams/selectedPluginCode", data.payload.PLUGIN_ID);
                vm.$store.commit("diagrams/selectedPluginUuid", data.payload.PLUGIN_UUID);
                this.disabledSavebtn = true;
            } else if (data.type === "CONTAINER_ADD_CHILD") { // adaug atribut nou
                vm.classUuid = data.payload.pluginUuid; // uuid clasa
                vm.editAtr = false;
                vm.parentClassData = data.payload;
                vm.classNameFromStore = data.payload.className;
                vm.showDlg = !vm.showDlg;
                vm.checkObjAttr = data.payload.atrributeObject;
                vm.indexAttr = null;
            } else if (data.type === "CELL_INDEPENDENT_CONTAINER_REMOVED") { // stergere clasa
                vm.classUuid = data.payload.pluginUUID;
                vm.isInEdit = false;
                vm.showDlgDataModal = false;
                vm.parentClassArray = vm.parentClassArray.filter(cat => cat.id !== vm.classUuid);
            } else if (data.type === "SELECTED_CONTAINER") {
                vm.classUuid = data.payload.pluginUuid;
                vm.isInEdit = false;
                vm.getClassDataForEdit(vm.classUuid);
            } else if (data.type === "SELECTED_CONTAINER_CHILD") { // edit attribute
                vm.propertyUuid = data.payload.childPluginUuid;
                this.indexAttr = data.payload.indexAtt;
                const parentClass = vm.parentClassArray.find(elem => elem.id === data.payload.pluginUuid);
                let parentClassName;
                vm.editAtr = true;
                if (parentClass) {
                    parentClassName = parentClass.name;
                }
                vm.parentClassData = {
                    ...data.payload,
                    className: parentClassName
                };
                vm.classUuid = data.payload.pluginUuid;
                vm.isInEdit = true;
                vm.getPropertyDataForEdit(vm.propertyUuid, this.indexAttr);
                vm.showDlg = !vm.showDlg;
            } else if (data.type === "SELECTED_CONTAINER_CHILD_NEW") { // edit atributes before save(draft) class
                vm.showDlg = !vm.showDlg;
                vm.editAtr = true;
                vm.getPropertyDataForAttribute(data.payload, data.indexAtt);
            }
            if (data.type === "DIAGRAM_STATE_MODIFICATIONS" && !this.showDlgDataModal) {
                this.$root.$emit("showCheckedSaveBtn", false);
            }
        },
        addClass(payload) {
            this.classToAdd = { ...payload };
            if (this.parentClassArray.length) {
                const foundClass = this.parentClassArray.find(el => el.id === payload.uuid);
                if (foundClass) { // edit Class
                    foundClass.isBCReady = payload.blockchain;
                    foundClass.name = payload.className;
                    foundClass.fields.forEach(field => {
                        field.classUuid = foundClass.id;
                        field.className = foundClass.name;
                        if (!field.id) { // adaug atribut(e)
                            this.addAttr(field);
                            field.id = this.childUuid;
                        } else {
                            this.editAttr(field);// editez atribut(e)
                        }
                    });
                } else { // add new class
                    this.addNewClass(this.attributes);
                }
            } else { // add first class in data model
                this.addNewClass(this.attributes);
            }
            this.disabledSavebtn = true;
        },
        addNewClass(data) {
            if (data && data.length) {
                for (let i = 0; i < data.length; i++) {
                    data[i].className = this.classToAdd.className;
                    data[i].classUuid = this.classToAdd.uuid;
                    this.addAttr(data[i]);
                    if (this.childUuid) {
                        data[i].id = this.childUuid;
                    }
                }
            }
        },
        editAttr(elem) {
            this.setParentClassArray(elem);
        },
        addAttr(elem) {
            if (this.attributes) {
                if (this.childUuid) {
                    elem.id = this.childUuid;
                }
                this.setParentClassArray(elem);
            }
        },
        getNoteData() {
            if (this.currentPreviewData) {
                const payload = {
                    module: "DataModel",
                    applicationId: this.currentApp.id,
                    elementId: this.id,
                    commitId: this.currentPreviewData.commitId
                };
                this.getNote(payload).then(data => {
                    if (data) {
                        this.note = data.data;
                        this.createNote = !this.note;
                        this.confirmLabel = this.note ? this.$t("versioning.updateNote") : this.$t("versioning.createNote");
                        this.noteDialogTitle = this.note
                            ? this.$t("versioning.dialogTitleEdit", { date: `${this.dateFormatter(this.currentPreviewData.timestamp)}` })
                            : this.$t("versioning.dialogTitleCreate", { date: `${this.dateFormatter(this.currentPreviewData.timestamp)}` });
                    }
                    this.noteDialog = true;
                });
            }
        },
        actionNote(noteData) {
            const payload = {
                module: "DataModel",
                applicationId: this.currentApp.id,
                elementId: this.id
            };
            payload.commitId = noteData ? noteData.timelineItem.commitId : this.currentPreviewData.commitId;
            payload.note = noteData ? noteData.note : this.note;
            let messageLabel = "";
            if (noteData) {
                messageLabel = this.dialogAction === "edit" ? this.$t("versioning.updateNoteDialog") : this.$t("versioning.saveNote");
            } else {
                messageLabel = this.confirmLabel === "Update" ? this.$t("versioning.updateNoteDialog") : this.$t("versioning.saveNote");
            }
            this.saveDeleteNote(payload).then((data) => {
                if (data) {
                    this.$toast.showNotify({
                        type: "success",
                        message: messageLabel,
                        timeout: 500,
                        hasClose: true
                    });
                    if (noteData) {
                        noteData.timelineItem.note = noteData.note;
                        this.keyUpdateDM += 1;
                    } else if (this.currentPreviewData) {
                        this.currentPreviewData.note = this.note;
                    }
                }
            },
            err => { console.log("error", err); });
        },
        formatAttributes(value) {
            const arrayToReturn = [];
            value.forEach(elem => {
                const { id, propertyName, propType, isList, isEmbeded, isIndexable, blockLabel, isPersonalInformation, isCat } = elem;
                arrayToReturn.push({
                    id,
                    name: propertyName,
                    type: propType,
                    isList,
                    isEmbeded,
                    isIndexable,
                    isBCReady: blockLabel,
                    isPersonalInformation,
                    notificationOnly: false,
                    isCat,
                    isReference: false

                });
            });
            return arrayToReturn;
        },
        setNoAddingYet(value) {
            this.noAddingYet = value;
        },
        getClassDataForEdit(payload) {
            const found = this.parentClassArray.find(element => element.id === payload);
            if (found) {
                this.classNameFromEdit = found.name;
                this.isBCReadyFromEdit = found.isBCReady;
            } else if (this.classToAdd) {
                this.classNameFromEdit = this.classToAdd.className;
            }
        },
        getPropertyDataForAttribute(data, index) {
            const { propertyName = "", propType = "", isPersonalInformation = "", isList = "", isIndexable = "", isEmbedded = "", isCat = "" } = data;
            this.propertyNameFromEdit = propertyName;
            this.propertyTypeFromEdit = propType;
            this.isEmbeddedFromEdit = isEmbedded;
            this.isCat = isCat;
            this.isIndexableFromEdit = isIndexable;
            this.isListFromEdit = isList;
            this.isPersonalInformationFromEdit = isPersonalInformation;
            this.indexAttr = index;
        },
        addAttributes(value) {
            this.attributes = value;
        },
        getPropertyDataForEdit(payload, indx) {
            let current;
            this.parentClassArray.find(element => element.fields.find(
                // eslint-disable-next-line no-return-assign
                (field, index) => field.id === payload && index === indx && (current = field)
            ));
            if (current) {
                const {
                    name = "", type = "", isBCReady = false, isEmbedded = false, isCat = false, isIndexable = false, isList = false,
                    isPersonalInformation = false
                } = current || {};
                this.propertyNameFromEdit = name;
                this.propertyTypeFromEdit = type;
                this.blockLabelFromEdit = isBCReady;
                this.isEmbeddedFromEdit = isEmbedded;
                this.isCat = isCat;
                this.isIndexableFromEdit = isIndexable;
                this.isListFromEdit = isList;
                this.isPersonalInformationFromEdit = isPersonalInformation;
            }
        },
        setParentClassArray(payload, action) {
            if (action === "closeModal") {
                this.disabledSavebtn = true;
                for (let i = 0; i < this.parentClassArray.length; i++) {
                    if (this.parentClassArray[i].id === payload.id) {
                        this.parentClassArray[i] = payload;

                        this.parentClassArray[i].fields.sort((a, b) => {
                            const attributeNameA = a.name.toLowerCase();
                            const attributeNameB = b.name.toLowerCase();
                            if (attributeNameA < attributeNameB) return -1;
                            if (attributeNameA > attributeNameB) return 1;
                            return 0;
                        });
                    }
                }
            } else if (action === "delete") {
                const classFound = this.parentClassArray.find(element => element.id === payload.classUuid);
                if (classFound) {
                    for (let i = 0; i < classFound.fields.length; i++) {
                        if (classFound.fields[i].id === payload.id) {
                            this.diagramAttrToDelete.push(payload.id);
                            classFound.fields.splice(i, 1);
                            break;
                        }
                    }
                }
                if (classFound.fields && classFound.fields.length > 0) {
                    this.disabledSavebtn = false;
                } else {
                    this.disabledSavebtn = true;
                }
            } else if (!this.noAddingYet) {
                const {
                    className, classUuid, propertyName, name, propType, type, blockLabel, isBCReady, isEmbeded, isIndexable, isList,
                    id, isPersonalInformation, isCat
                } = payload;
                const classFound = this.parentClassArray.find(element => element.id === classUuid);
                if (classFound) {
                    const fieldFound = classFound.fields.find((field, index) => (id ? field.id === id : index === this.indexAttr));
                    if (fieldFound) {
                        fieldFound.name = propertyName || name;
                        fieldFound.type = propType || type;
                        fieldFound.isBCReady = blockLabel || isBCReady;
                        fieldFound.isEmbeded = isEmbeded;
                        fieldFound.isIndexable = isIndexable;
                        fieldFound.isList = isList;
                        fieldFound.isCat = isCat;
                        fieldFound.isPersonalInformation = isPersonalInformation;
                        fieldFound.id = id;
                        if (fieldFound.fields) {
                            delete fieldFound.fields;
                        }
                    } else {
                        classFound.fields.push({
                            name: propertyName || name,
                            type: propType || type,
                            isBCReady: blockLabel || isBCReady,
                            isEmbeded,
                            isIndexable,
                            isList,
                            id,
                            isCat,
                            isPersonalInformation
                        });
                    }
                    classFound.fields.sort((a, b) => {
                        const attributeNameA = a.name.toLowerCase();
                        const attributeNameB = b.name.toLowerCase();
                        if (attributeNameA < attributeNameB) return -1;
                        if (attributeNameA > attributeNameB) return 1;
                        return 0;
                    });
                } else {
                    this.parentClassArray.push({
                        name: className,
                        isBCReady: this.classToAdd.blockchain,
                        id: classUuid,
                        fields: [
                            {
                                name: propertyName,
                                type: propType,
                                isBCReady: blockLabel,
                                isEmbeded,
                                isIndexable,
                                isList,
                                isCat,
                                id: this.childUuid || id,
                                isPersonalInformation
                            }
                        ]
                    });
                }
                this.disabledSavebtn = false;
            }
        },
        setGeneralModelDef(reqResponse) {
            let masterId = null;
            if (reqResponse) {
                this.dataFromGetResponse = JSON.parse(JSON.stringify(reqResponse.data));
                this.diagramId = this.dataFromGetResponse.diagramId;
                masterId = this.dataFromGetResponse.masterId;
                this.parentClassArray = JSON.parse(JSON.stringify(reqResponse.data.modelClasses));
                this.sortParentArray();
            }

            this.noAddingYet = true;
            this.$store.commit("catalogs/setMasterId", masterId);
        },
        modalClosed(event) {
            if (event && typeof event.isInEdit === "boolean") {
                this.sendBlockChainToggle = event.sendBlockChainToggle;
            } else if (typeof event === "boolean") {
                this.showDlgDataModal = false;
                setTimeout(() => {
                    this.showDlg = !this.isInEdit;
                }, 0);
            } else if (event === "fromCloseModal") {
                this.showDlgDataModal = false;
                this.showDlg = false;
            } else {
                this.showDlg = false;
            }
        },
        refreshData(data) {
            this.oneAtATimeActive = data;
            getDataModel(data).then(this.setGeneralModelDef);
            this.refreshNotify();
            this.$store.commit("main/setInterfaceDirty", false);
        },
        onKeyUp(ev) {
            // Undo & Redo
            const emitEvents = true;
            if (ev.ctrlKey && ev.keyCode === 90) {
                // ctrl + Z
                this.$refs.diagram.undoState(emitEvents);
            } else if (ev.ctrlKey && ev.keyCode === 89) {
                // ctrl + Y
                this.$refs.diagram.redoState(emitEvents);
            }
        },
        checkPermissions(oneAtATimeParams) {
            const hasPermissions = this.$route.params && this.$route.params.permissions && this.$route.params.permissions.permissionsData
                ? this.$route.params.permissions.permissionsData
                : null;

            if (hasPermissions && hasPermissions.hasOwnProperty(this.permissionCode) && hasPermissions[this.permissionCode] === "r") {
                this.readonly = true;
                this.$store.commit("main/setSaveBtnVisible", this.readonly);
                this.$root.$emit("setReadonlyTag", this.readonly);
            } else if (oneAtATimeParams && oneAtATimeParams.hasOwnProperty("readonly")) {
                this.readonly = oneAtATimeParams.readonly;
                this.$store.commit("main/setSaveBtnVisible", this.readonly);
                this.$root.$emit("setReadonlyTag", this.readonly);
            } else if (this.readonly) {
                this.readonly = false;
                this.$store.commit("main/setSaveBtnVisible", this.readonly);
                this.$root.$emit("setReadonlyTag", this.readonly);
            }
        },
        refreshDataWebsocket() {
            if (!this.$oneAtATime.state.$currentRoomEmpty && this.$route.name === "dataModel" && !this.toastExist) {
                this.dataUpdateNotify = this.$toast.showNotify({
                    type: "info",
                    message: `${this.$t("dataModel.dataModelUpdateToast")} `,
                    buttonLabel: `${this.$t("dataModel.refresh")}`,
                    timeout: 0,
                    hasClose: false,
                    actionEvent: this.getDataModelData
                });
                this.toastExist = true;
            }
        },
        getDataModelData() {
            getDataModel().then(data => {
                if (data.data.modelClasses && data.data.modelClasses.length === 0) {
                    this.emptyState = true;
                } else {
                    this.initialDataModel = [...data.data.modelClasses];
                    this.emptyState = false;
                    this.setGeneralModelDef(data);
                }
                this.refreshNotify();
            });
        },
        refreshNotify() {
            if (this.dataUpdateNotify) {
                this.dataUpdateNotify();
                this.toastExist = false;
            }
        },
        saveHistoryAction(event) {
            if (event === "close") {
                this.saveHistoryDMModal = false;
                this.savePreviewToast = this.actionMade || this.previewDone ? this.$toast.showNotify({
                    type: "info",
                    message: `${i18n.t("versioning.previewToastTitle")} ${this.dateFormatter(this.timeStampPreview)}`,
                    caption: this.$t("versioning.previewToastText"),
                    code: "preview-ui",
                    timeout: 30000000
                }) : null;
                this.actionMade = false;
            }
        },
        getSaveHistoryDM() {
            if (this.saveHistoryDMHasMoreItems) {
                const payload = {
                    searchType: "SAVE_HISTORY",
                    module: "DataModel",
                    applicationId: this.currentApp.id,
                    elementId: this.id,
                    page: this.saveHistoryCurrentPage,
                    size: 10
                };
                this.getHistoryData(payload).then(data => {
                    this.saveHistoryData = this.saveHistoryData.concat(data.data.history);
                    this.saveHistoryDMHasMoreItems = data.data.hasMorePages;
                    this.actionMade = false;
                    if (this.unsavedChanges) {
                        this.$store.commit("main/setInterfaceDirty", true);
                    }
                    this.saveHistoryDMModal = true;
                });
            } else {
                this.actionMade = false;
                this.saveHistoryDMModal = true;
            }
        },
        getSaveHistoryItem(event) {
            if (!this.standaloneTypes.has(event.commitType)) {
                this.actionMade = true;
                this.currentPreviewData = event;
                if (this.interfaceDirty) {
                    this.openDialogDraftPreview = this.interfaceDirty;
                } else {
                    this.getSaveHistoryDMPreview();
                }
            }
        },
        getSaveHistoryDMPreview(fromDraft) {
            if (fromDraft) {
                this.$store.commit("main/setInterfaceDirty", false);
            }
            if (!this.standaloneTypes.has(this.currentPreviewData.commitType)) {
                this.$root.$emit("previewSaveHistoryLoadStart", this.$route.name); // close si restore apar disabled
                const payload = {
                    module: "DataModel",
                    applicationId: this.currentApp.id,
                    elementId: this.id,
                    commitId: this.currentPreviewData.commitId
                };
                this.getHistoryDMPreviewData(payload).then(data => {
                    if (data && data.data) {
                        this.$root.$emit("previewSaveHistoryLoadEnd", this.$route.name); // close si restore apar enabled + notes
                        this.$root.$emit("hideSaveBtn", true);
                        this.$root.$emit("showPublish", false);
                        this.readonly = true;
                        this.parentClassArray = data.data.modelClasses;
                        this.emptyState = !data.data.modelClasses;
                        this.saveHistoryActiveCommitId = data.data.commitId || this.currentPreviewData.commitId;
                        this.timeStampPreview = data.data.timestamp;
                        this.previewDone = true;
                        this.dirtyFromRestore = false;
                        this.sortParentArray();
                    } else {
                        this.$root.$emit("previewSaveHistoryClose", this.$route.name);
                    }
                });
            }
        },
        dateFormatter(dateToFormat) {
            const newData = dateToFormat ? date.formatDate(dateToFormat, APP_DATE_DOT_FORMAT).split(".") : "";
            const data = new Date();
            data.setMonth(newData[1] - 1);
            const year = newData[2].split(" ")[0];
            const hour = newData[2].split(" ")[1].substring(0, 5);
            return `${data.toLocaleString("en-US", { month: "long" })} ${newData[0]}, ${year}  ${i18n.t("versioning.at")} ${hour}`;
        },
        changeSearchUrl(value) {
            const searchText = value.trim();
            const queriesAreDifferent = JSON.stringify({ search: searchText }) !== JSON.stringify(this.$route.query);
            const query = searchText ? { search: searchText } : {};
            if (queriesAreDifferent && this.isActive) {
                this.$router.replace({ path: `/applications/${this.currentApp.id}/dataModel`, query });
            }
            this.$store.commit("main/setInterfaceDirty", false);
        }
    }
};
